import { Alert, styled } from "@mui/material";

export const StyledError = {
  Root: styled("div")(({ theme }) => ({
    height: "95vh",
    display: "flex",
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  })),
  Logo: styled("img")(({ theme }) => ({
    marginBottom: "20px",
  })),
  Alert: styled(Alert)(({ theme }) => ({
    marginTop: "20px",
  })),
};
